// extracted by mini-css-extract-plugin
module.exports =  {"icon":"icon--peNriFGGvfsESYE8tKkyJg==","iconFlipped":"iconFlipped--0Gpf8xF+sT78GO1E9nhlXg=="};